import { RAGE_CLICK_TYPE } from './RageClickFilterType';

export const OPTION_LIST = [
  { value: RAGE_CLICK_TYPE.OCCURRED, label: 'occurred' },
  { value: RAGE_CLICK_TYPE.DID_NOT_OCCUR, label: 'did not occur' },
];
